"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrors = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ramda = require("ramda");

var getErrors = function getErrors(fieldName) {
  var validationErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var serverErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var fieldValidationError = validationErrors[fieldName];
  var frontErrors = fieldValidationError ? (0, _defineProperty2["default"])({}, fieldName, [fieldValidationError.message]) : {};
  return (0, _ramda.mergeDeepRight)(frontErrors, serverErrors);
};

exports.getErrors = getErrors;